// extracted by mini-css-extract-plugin
module.exports = {"switchContainer":"styles_switchContainer__2Pgvr","switch":"styles_switch__dRUgM","switchLabel":"styles_switchLabel__331rk"};